import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.19_@babel+core@7.28.5_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_babe_39a4e7992ab4a0174bf7da6fa6c56d96/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.19_@babel+core@7.28.5_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_babe_39a4e7992ab4a0174bf7da6fa6c56d96/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.19_@babel+core@7.28.5_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_babe_39a4e7992ab4a0174bf7da6fa6c56d96/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.19_@babel+core@7.28.5_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_babe_39a4e7992ab4a0174bf7da6fa6c56d96/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/layout.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/badge/badge-factory.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NumberedBadge"] */ "/app/src/app/components/badge/layouts/numbered/numbered-badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextBadge"] */ "/app/src/app/components/badge/layouts/text/text-badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BottomBarClient"] */ "/app/src/app/components/bottom-bar/bottom-bar.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CanaryExposure"] */ "/app/src/app/components/canary-exposure/canary-exposure.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/debug-menu/debug-menu.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/error-boundary/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterRouteGate"] */ "/app/src/app/components/footer/footer-route-gate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentButton"] */ "/app/src/app/components/footer/subcomponents/footer-links/cookie-consent-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwitchRegionButton"] */ "/app/src/app/components/footer/subcomponents/footer-links/switch-region-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RegulatoryLogos"] */ "/app/src/app/components/footer/subcomponents/regulatory-logos/regulatory-logos.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StateGcbLogo"] */ "/app/src/app/components/footer/subcomponents/state-gcb-logo/state-gcb-logo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game-badge-image/game-badge-image.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/layouts/simplified-row/styles/poker.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/layouts/daily-jackpot/styles/default.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/layouts/trending/styles/poker.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/layouts/animated-trailer/styles/default.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/layouts/default/styles/poker.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/subcomponents/animated-tile/animated-tile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JackpotAmountAndTime"] */ "/app/src/app/components/game/subcomponents/daily-jackpot/daily-jackpot-amount-time.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JackpotDescription"] */ "/app/src/app/components/game/subcomponents/daily-jackpot/daily-jackpot-description.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/subcomponents/details/game-details.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/subcomponents/game-url/game-url.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/subcomponents/info-button/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/subcomponents/swj-border-overlay/swj-border-overlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccountHubButton"] */ "/app/src/app/components/header/subcomponents/header-buttons/account-hub/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthenticationButtons"] */ "/app/src/app/components/header/subcomponents/header-buttons/authentication-buttons/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Balance"] */ "/app/src/app/components/header/subcomponents/header-buttons/balance/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationBtn"] */ "/app/src/app/components/header/subcomponents/header-buttons/notification/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopNavImpressionTracker"] */ "/app/src/app/components/header/subcomponents/nav/top-nav-impression-tracker.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/header/subcomponents/responsible-gambling/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/loading-spinner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LobbyBackgroundLock"] */ "/app/src/app/components/lobby-background-lock/lobby-background-lock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopupClient"] */ "/app/src/app/components/popup/popup.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/search-drawer/search-drawer-container.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecommendedGamesReadySentinel"] */ "/app/src/app/components/search-drawer/subcomponents/recommended-games/recommended-games-ready-sentinel.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/search-drawer/subcomponents/recommended-games/styles/poker.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/styles/poker.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/header/styles/poker.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/header/subcomponents/header-content/styles/poker.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/header/subcomponents/header-buttons/user-details/styles/default.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/header/subcomponents/nav/styles/poker.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/header/subcomponents/regulatory-logos/styles/default.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/footer/subcomponents/footer-legal/styles/poker.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/footer/subcomponents/footer-links/styles/poker.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/footer/styles/poker.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/bottom-bar/styles/poker.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Search"] */ "/app/src/app/components/search/search.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/site-wide-jackpot/subcomponents/jackpot-ticker/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/site-wide-jackpot/subcomponents/ticker-pill/ticker-pill.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SmartBannerClient"] */ "/app/src/app/components/smart-banner/smart-banner.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CurrentTime"] */ "/app/src/app/elements/current-time/current-time.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DraggableContainer"] */ "/app/src/app/elements/draggable-wrapper/draggable-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FavoritesButton"] */ "/app/src/app/elements/favorites-button/favorites-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavItem"] */ "/app/src/app/elements/nav-item/nav-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Video"] */ "/app/src/app/elements/video/video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExperimentExposureProvider"] */ "/app/src/tracking/amplitude/exposure/experiment-exposure-provider.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/tracking/tracking-manager.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/utils/cookies/client.ts");
